import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import GlobalApi from "../../Global";
import refresh_token from "../../Global/refresh_token";
import "./analytic.css";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Progress from "react-circle-progress-bar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Fab from "@material-ui/core/Fab";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import { saveAs } from "file-saver";
import useDimensions from "../../Global/useDimensions";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import DarkButton from "../../Global/DarkButton";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import moment from "moment";
import swal from "@sweetalert/with-react";
import _ from "lodash";
import Chart from "react-google-charts";
import Colors from "../../Global/colors";
import Spinner from "../../Global/Spinner";
import { Dashboard } from "./Dashboard/Dashboard";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";


export default function Analytics(props) {
  let company = useSelector((state) => state.companyReducer.company);
  let companies = useSelector((state) => state.companyArrReducer.company);
  const {t} = useTranslation();
  const history = useHistory();
  const { width } = useDimensions();
  const [value, setValues] = React.useState({
    from: moment()
      .subtract(9, "days")
      .toDate(),
    end: new Date(),
    custom_selected: "",
    company_id:'',
  });

  console.log('VALUE))))))))))))))))))))))))))))',value)
  const [downloadIndex, setDownloadIndex] = React.useState(null);
  const [templates, setTemplates] = React.useState([]);
  // const [companies, setCompanies] = React.useState([]);
  const [inspections, setInspections] = React.useState([]);
  const [sites, setSites] = React.useState([]);
  const [filteredInspection, setFilteredInspection] = React.useState([]);
  const [btnLoader, setBtnLoader] = React.useState(false);
  const [barChartData, setBarChartData] = React.useState([]);
  const [dateChart, setDateChart] = React.useState([]);
  const [tableData, setTableData] = React.useState([]);

  const [tableFilterOption, setTableFilterOption] = React.useState("");
  const [tableFilterDate, setTableFilterDate] = React.useState("");
  const [dataGlobal, setDataGlobal] = React.useState({
    location: 0,
    audit_name: 0,
    auditors: 0,
    audits: 0,
  });

  const [packageDetails, setPackageDetails] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [openModalDashboard,setModalDashboard]=React.useState(false)
  const setModal=(tab,state)=>{
    setModalDashboard(state)
  }
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  console.log("COMPANY",company)

  React.useEffect(() => {
    // props.func();
    getTemplates(company.id);
    getInspections(company.id);
    getSites(company.id);
    getPackageDetails();
  }, [company?.id]);

  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  function getTemplates(currentCompany) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Template/get_all_templates?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setTemplates(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          // console.log(status);
          if (status) {
            getTemplates(currentCompany);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getInspections(currentCompany) {
    console.log("+++++++++++++++++++++++++++++++++++++Get Inspections Called")
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Schedule/get_all_schedules_organization?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response,"inspections**************************************");
        if (response.status === "Success") {
          await setInspections(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getInspections(currentCompany);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getSites(currentCompany) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let arr = [];
        data.data.map((value, index) => {
          //console.log(value.title);
          value.Areas.map((area, i) => {
            area.Sites.map((sites, j) => {
              // console.log(value.title, area.title, sites.title);
              let obj = {
                title: sites.title,
                id: sites.id,
              };
              if (sites.status !== "deactivated") {
                arr.push(obj);
              }
              //console.log(obj);
              setSites(arr);
            });
            //console.log(this.state.row);
            //console.log(result.title,value.title);
          });
        });
      });
  }

  function handleSideBarChange(event) {
    // let { value, name } = event.target;

    // console.log(name, value);
    setValues({
      ...value,
      [event.target.name]: event.target.value,
    });

    if(event.target.name == "company_id"){
      console.log("event.target.value",event.target.value)
      getInspections(event.target.value);
      getSites(event.target.value);
      getTemplates(event.target.value);
      setValues({
        ...value,
        company_id:event.target.value,
        template_id:"",
        schedule_id:'',
        site_id:'',
      });
    }
  }

  async function handleSideBarSubmit(reset) {
    setOpen(false);
    let data_arr = [
      [
        "Template",
        "score",
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    let data_obj = {};
    let inspection_obj = {};
    let inspection_obj_new = {};
    let data_obj_new = {};
    let user_obj = {};
    let site_clone = [];
    let inspection_clone = [];
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id:  value.company_id ? value.company_id :company.id,
      end_date: value.end,
      from_date: value.from,
      schedule_id: value.schedule_id?.id,
      template_id: value.template_id?.id,
      site_id: value.site_id?.id,
    };
    console.log(params, "PARAMS________________________________________________________");
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(
      GlobalApi + "/Inspection/get_all_inspections_analytics_new?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("test response" , response)
        if (response.status === "Success") {
          setFilteredInspection(response.data);
          
          await response.data.map(async (n,ind) => {
            let score_arr = [];
            if (
              reset
                ? true
                : (value.site_id?.id
                    ? n.Schedule?.site === value.site_id?.id
                    : true) &&
                  (value.template_id?.id
                    ? n.Schedule?.template_id === value.template_id?.id
                    : true) &&
                  (value.schedule_id?.id
                    ? n.schedule_id === value.schedule_id?.id
                    : true)
            ) {
              // console.log("P{P{");
              site_clone.push(n.Schedule.Site);
              inspection_clone.push(n);


              data_obj_new = {
                ...data_obj_new,
                [n.TemplateInspection?.title]: data_obj_new[
                  (n.TemplateInspection?.title)
                ]
                  ? [
                      ...data_obj_new[(n.TemplateInspection?.title)],
                      {
                        score:parseInt(n.score),
                          // ((filtered_answers.length -
                          //   (filtered_answers.length - score_arr.length)) /
                          //   filtered_answers.length) *
                          // 100,
                        title: n.TemplateInspection?.title,
                        schedule_id: n.Schedule?.id,
                        template_id: n.Template?.id,
                        site_id: n.Schedule?.site,
                      },
                    ]
                  : [
                      {
                        score:parseInt(n.score),
                          // ((filtered_answers.length -
                          //   (filtered_answers.length - score_arr.length)) /
                          //   filtered_answers.length) *
                          // 100,
                        title: n.TemplateInspection?.title,
                        schedule_id: n.Schedule?.id,
                        template_id: n.Template?.id,
                        site_id: n.Schedule?.site,
                      },
                    ],
              };

              inspection_obj_new = {
                ...inspection_obj_new,
                [n.Schedule?.title]: inspection_obj_new[(n.Schedule?.title)]
                  ? [
                      ...inspection_obj_new[(n.Schedule?.title)],
                      {
                        score:parseInt(n.score),
                          // ((filtered_answers.length -
                          //   (filtered_answers.length - score_arr.length)) /
                          //   filtered_answers.length) *
                          // 100,
                        title: n.Schedule?.title,
                        template_id: n.Template?.id,
                        schedule_id: n.Schedule?.id,
                        site_id: n.Schedule?.site,
                      },
                    ]
                  : [
                      {
                        score:parseInt(n.score),
                          // ((filtered_answers.length -
                          //   (filtered_answers.length - score_arr.length)) /
                          //   filtered_answers.length) *
                          // 100,
                        title: n.Schedule?.title,
                        template_id: n.Template?.id,
                        schedule_id: n.Schedule?.id,
                        site_id: n.Schedule?.site,
                      },
                    ],
              };




              // let filtered_answers = n.InspectionAnswers?.filter(
              //   (v) => v.parent_id == null
              // );

              // await filtered_answers?.map(async (ans, iAns) => {

               
              //   if (
              //     ans.value == null ||
              //     ans.value == "" ||
              //     ans.value == 0 ||
              //     ans.value == "[]" ||
              //     ans.value?.length == 0 ||
              //     ans.parent_id !== null
              //   ) {
              //   } else score_arr.push(ans);

              //   console.log("test score_arr", ind , ":"  , score_arr)


              //   if (filtered_answers.length - 1 === iAns) {
        
              //     data_obj = {
              //       ...data_obj,
              //       [n.TemplateInspection?.title]: data_obj[
              //         (n.TemplateInspection?.title)
              //       ]
              //         ? [
              //             ...data_obj[(n.TemplateInspection?.title)],
              //             {
              //               score:parseInt(n.score),
              //                 // ((filtered_answers.length -
              //                 //   (filtered_answers.length - score_arr.length)) /
              //                 //   filtered_answers.length) *
              //                 // 100,
              //               title: n.TemplateInspection?.title,
              //               schedule_id: n.Schedule?.id,
              //               template_id: n.Template?.id,
              //               site_id: n.Schedule?.site,
              //             },
              //           ]
              //         : [
              //             {
              //               score:parseInt(n.score),
              //                 // ((filtered_answers.length -
              //                 //   (filtered_answers.length - score_arr.length)) /
              //                 //   filtered_answers.length) *
              //                 // 100,
              //               title: n.TemplateInspection?.title,
              //               schedule_id: n.Schedule?.id,
              //               template_id: n.Template?.id,
              //               site_id: n.Schedule?.site,
              //             },
              //           ],
              //     };

              //     inspection_obj = {
              //       ...inspection_obj,
              //       [n.Schedule?.title]: inspection_obj[(n.Schedule?.title)]
              //         ? [
              //             ...inspection_obj[(n.Schedule?.title)],
              //             {
              //               score:parseInt(n.score),
              //                 // ((filtered_answers.length -
              //                 //   (filtered_answers.length - score_arr.length)) /
              //                 //   filtered_answers.length) *
              //                 // 100,
              //               title: n.Schedule?.title,
              //               template_id: n.Template?.id,
              //               schedule_id: n.Schedule?.id,
              //               site_id: n.Schedule?.site,
              //             },
              //           ]
              //         : [
              //             {
              //               score:parseInt(n.score),
              //                 // ((filtered_answers.length -
              //                 //   (filtered_answers.length - score_arr.length)) /
              //                 //   filtered_answers.length) *
              //                 // 100,
              //               title: n.Schedule?.title,
              //               template_id: n.Template?.id,
              //               schedule_id: n.Schedule?.id,
              //               site_id: n.Schedule?.site,
              //             },
              //           ],
              //     };
              //   }
              // });

              n.InspectionShares.map((user) => {
                let name = user.User?.first_name + " " + user.User?.last_name;

                user_obj = {
                  ...user_obj,
                  [user?.User?.id]: user_obj[(user?.User?.id)]
                    ? [
                        ...user_obj[(user?.User?.id)],
                        { name, inspection_id: n.id },
                      ]
                    : [{ name, inspection_id: n.id }],
                };
              });
            }
          });


              console.log("test data_obj_new", data_obj_new)
              console.log("test inspection_obj_new", inspection_obj_new)


          let objKeys = Object.keys(data_obj_new);
          let site_obj = {};

          console.log("test objKeys" , objKeys)


          await objKeys.map(async (v) => {
            let overall_score = 0;

            await data_obj_new[v].map((val, valI) => {
              site_obj[val.site_id] = val.site_id;
              overall_score += val.score;
              if (valI === data_obj_new[v].length - 1) {
                data_arr.push([
                  val.title,
                  overall_score / data_obj_new[v].length,
                  val.title,
                ]);
              }
            });
          });



          let table_arr = [];
          await inspection_clone.map(async (v) => {
            console.log("VVB",v)
            table_arr.push({
              title: v.Schedule.title,
              schedule_id: v.Schedule?.id,
              site_id: v.Schedule?.site,
              template_id: v.Schedule?.template_id,
              template: v.TemplateInspection.title,
              id: v.id,
              site: v.Schedule.Site?.title,
              date: v.createdAt,
              isCompleted: v.isCompleted,
              pdf_url:v.pdf_url,
              commentsArr: v.InspectionComments.filter(
                
                (v) => { 
                  //alert(JSON.stringify(v.HierarchyOrganization))
                return v?.HierarchyOrganization?.position === "1"
                
               }
              ),
              comment:
                v.InspectionComments.filter(
                  (v) => v?.HierarchyOrganization?.position === "1"
                )?.length !== 0
                  ? v.InspectionComments.filter(
                      (v) => v?.HierarchyOrganization?.position === "1"
                    )[0]?.status === "Approved"
                    ? true
                    : false
                  : 'In Approval',
              //commentsArr:v.InspectionComments,
              score:parseInt(v.score),
                // ((filtered_answers.length -
                //   (filtered_answers.length - score_arr.length)) /
                //   filtered_answers.length) *
                // 100,
            });


            // let score_arr = [];

            // let filtered_answers = v.InspectionAnswers?.filter(
            //   (v) => v.parent_id == null
            // );
            // await filtered_answers?.map(async (ans, iAns) => {
            //   if (
            //     ans.value == null ||
            //     ans.value == "" ||
            //     ans.value == 0 ||
            //     ans.value == "[]" ||
            //     ans.value?.length == 0 ||
            //     ans.parent_id !== null
            //   ) {
            //   } else score_arr.push(ans);
            // });
            //console.log(JSON.stringify(v.InspectionComments),"Inspection Comments...")
            
            // table_arr.push({
            //   title: v.Schedule.title,
            //   schedule_id: v.Schedule?.id,
            //   site_id: v.Schedule?.site,
            //   template_id: v.Schedule?.template_id,
            //   template: v.TemplateInspection.title,
            //   id: v.id,
            //   site: v.Schedule.Site?.title,
            //   date: v.createdAt,
            //   isCompleted: v.isCompleted,
            //   commentsArr: v.InspectionComments.filter(
                
            //     (v) => { 
            //       //alert(JSON.stringify(v.HierarchyOrganization))
            //     return v?.HierarchyOrganization?.position === "1"
                
            //    }
            //   ),
            //   comment:
            //     v.InspectionComments.filter(
            //       (v) => v?.HierarchyOrganization?.position === "1"
            //     )?.length !== 0
            //       ? v.InspectionComments.filter(
            //           (v) => v?.HierarchyOrganization?.position === "1"
            //         )[0]?.status === "Approved"
            //         ? true
            //         : false
            //       : 'In Approval',
            //   //commentsArr:v.InspectionComments,
            //   score:
            //     ((filtered_answers.length -
            //       (filtered_answers.length - score_arr.length)) /
            //       filtered_answers.length) *
            //     100,
            // });
          });
          console.log(table_arr, "table_arr");

          setTableData(table_arr);
          setDataGlobal({
            ...dataGlobal,
            location: Object.keys(site_obj).length,
            auditors: Object.keys(user_obj).length,
            audit_name: Object.keys(inspection_obj_new).length,
            audits: table_arr.length,
            template_id: value.template_id?.id,
            inspection_id: value.inspection_id?.id,
            site_id: value.site_id?.id,
            site_obj: site_obj,
            user_obj: user_obj,
            data_obj: data_obj_new,
            site_clone,
            name_arr: data_arr,
            inspection_clone,
          });
          handleDateChart(inspection_clone);
          setBtnLoader(false);
          setModal("dashboard",false)

          console.log("test data_arr" , data_arr)
          if (data_arr.length > 1) {
            setBarChartData(data_arr);
          } else {
            setBarChartData([]);
          }
        }
      });
  }

  async function handleDateChart(inspection_clone) {
    let data_arr = [["date", "count"]];

    var dates = getDates(
      new Date(
        moment()
          .subtract(7, "days")
          .toDate()
      ),
      new Date()
    );

    console.log(dates);
    let group_dates_1 = await _.groupBy(inspection_clone, (v) =>
      new Date(v.createdAt).getDate()
    );

    let fake_data_in = await inspection_clone.map((v) => {
      // console.log(group_dates_1[new Date(v.createdAt).getDate()].length);
      return [
        new Date(v.createdAt).getDate(),
        group_dates_1[new Date(v.createdAt).getDate()],
        new Date(v.createdAt),
      ];
    });

    // console.log(fake_data_in);
    let group_dates = await _.groupBy(fake_data_in, (v) => v[0]);

    let fake_data = await dates.map((v) => {
      return [v.getDate(), [], v];
    });
    // console.log("+++", fake_data)

    let group_dates_2 = await _.groupBy(fake_data, (v) => v[0]);
    console.log(group_dates_2, group_dates);
    let group = {
      ...group_dates_2,
      ...group_dates,
    };

    console.log(group);
    await Object.keys(group).map((v, i) => {
      // console.log(group[v][0][2]);
      data_arr.push([v, group[v][0][1].length, group[v][0][2]]);
    });

    // await dates.map((v, i) => {
    //   data_arr.push([i, v.getDate()]);
    // });

    // let final_arr = []

    let final_arr = await data_arr
      .sort(
        (a, b) =>
          parseInt(new Date(a[2]).getTime()) -
          parseInt(new Date(b[2]).getTime())
      )
      .map((v) => {
        // console.log(v[2]);
        return [moment(v[2]).format("MMMM DD, YYYY"), v[1]];
      });
    setDateChart(final_arr.slice(2, 10));

    // console.log(final_arr);
  }

  async function toggletable(row, colomn) {
    console.log("row",row)
    // console.log(barChartData[0][0]);
    // console.log(barChartData[row + 1][2]);
    let arr = [];

    if (barChartData[0][0] === "Template") {
  
      await filteredInspection.map(async (v) => {
        console.log("Testing Data", v)
        let score_arr = [];
        if (
          // v.Schedule.template_id
          (v.Schedule.title === barChartData[row + 1][2] ||
            v.TemplateInspection.title === barChartData[row + 1][2]) &&
          (value.site_id?.id ? v.Schedule?.site === value.site_id?.id : true)
        ) {


          // let filtered_answers = v.InspectionAnswers?.filter(
          //   (v) => v.parent_id == null
          // );
          // await filtered_answers?.map(async (ans, iAns) => {
          //   if (
          //     ans.value == null ||
          //     ans.value == "" ||
          //     ans.value == 0 ||
          //     ans.value == "[]" ||
          //     ans.value?.length == 0 ||
          //     ans.parent_id !== null
          //   ) {
          //   } else score_arr.push(ans);
          // });

          arr.push({
            title: v.Schedule.title,
            site: v.Schedule.Site?.title,
            date: v.createdAt,
            template: v.TemplateInspection.title,
            id: v.id,
            score:parseInt(v.score),
              // ((filtered_answers.length -
              //   (filtered_answers.length - score_arr.length)) /
              //   filtered_answers.length) *
              // 100,
            schedule_id: v.Schedule?.id,
            site_id: v.Schedule?.site,
            template_id: v.Schedule?.template_id,
          });
        }
      });
    }

    if (barChartData[0][0] === "Site") {
      // console.log("site");
      await filteredInspection.map(async (v) => {
        let score_arr = [];
        if (v.Schedule?.Site?.title === barChartData[row + 1][2]) {
          
          

          arr.push({
            title: v.Schedule.title,
            site: v.Schedule.Site.title,
            template: v.TemplateInspection.title,
            id: v.id,

            date: v.createdAt,
            score:parseInt(v.score),
              // ((filtered_answers.length -
              //   (filtered_answers.length - score_arr.length)) /
              //   filtered_answers.length) *
              // 100,
            schedule_id: v.Schedule?.id,
            site_id: v.Schedule?.site,
            template_id: v.Schedule?.template_id,
          });


          // let filtered_answers = v.InspectionAnswers?.filter(
          //   (v) => v.parent_id == null
          // );
          // await filtered_answers?.map(async (ans, iAns) => {
          //   if (
          //     ans.value == null ||
          //     ans.value == "" ||
          //     ans.value == 0 ||
          //     ans.value == "[]" ||
          //     ans.value?.length == 0 ||
          //     ans.parent_id !== null
          //   ) {
          //   } else score_arr.push(ans);
          // });

          // arr.push({
          //   title: v.Schedule.title,
          //   site: v.Schedule.Site.title,
          //   template: v.TemplateInspection.title,
          //   id: v.id,

          //   date: v.createdAt,
          //   score:
          //     ((filtered_answers.length -
          //       (filtered_answers.length - score_arr.length)) /
          //       filtered_answers.length) *
          //     100,
          //   schedule_id: v.Schedule?.id,
          //   site_id: v.Schedule?.site,
          //   template_id: v.Schedule?.template_id,
          // });
        }
      });
    }

    if (barChartData[0][0] === "User") {
      // console.log("user");
      await Object.keys(dataGlobal.user_obj).map((key, i) => {
        dataGlobal.user_obj[key].map(async (id) => {
          await filteredInspection.map(async (v) => {
            let score_arr = [];
            if (v.id === id.inspection_id && row === i) {
              
              // let filtered_answers = v.InspectionAnswers?.filter(
              //   (v) => v.parent_id == null
              // );
              // await filtered_answers?.map(async (ans, iAns) => {
              //   if (
              //     ans.value == null ||
              //     ans.value == "" ||
              //     ans.value == 0 ||
              //     ans.value == "[]" ||
              //     ans.value?.length == 0 ||
              //     ans.parent_id !== null
              //   ) {
              //   } else score_arr.push(ans);
              // });

              arr.push({
                title: v.Schedule.title,
                site: v.Schedule.Site?.title,
                template: v.TemplateInspection.title,
                id: v.id,

                date: v.createdAt,
                score:parseInt(v.score),
                  // ((filtered_answers.length -
                  //   (filtered_answers.length - score_arr.length)) /
                  //   filtered_answers.length) *
                  // 100,
                schedule_id: v.Schedule?.id,
                site_id: v.Schedule?.site,
                template_id: v.Schedule?.template_id,
              });
            }
          });
        });
      });
    }

    setTableData(arr);
  }

  function handleAuditClick() {
    handleSideBarSubmit();
  }

  async function handleLocationClick() {
    // console.log(dataGlobal.site_clone);
    let data_arr = [
      [
        "Site",
        "No of Inspections",
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    let site_obj_1 = _.groupBy(dataGlobal.site_clone, function(site) {
      return site?.title;
    });

    // console.log(site_obj_1);

    await Object.keys(site_obj_1).map((v) => {
      data_arr.push([v, site_obj_1[v].length, v]);
    });

    setBarChartData(data_arr);
  }

  async function handleNameClick() {
    let data_arr = [
      [
        "Template",
        "score",
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    let data_obj = {};
    // console.log(
    //   value.site_id?.id,
    //   value.template_id?.id,
    //   value.inspection_id?.id
    // );

    let user_obj = {};
    let site_clone = [];
    let inspection_clone = [];
    await filteredInspection.map(async (n) => {
      let score_arr = [];
      if (
        (value.site_id?.id ? n.Schedule?.site === value.site_id?.id : true) &&
        (value.template_id?.id
          ? n.Schedule?.template_id === value.template_id?.id
          : true) &&
        (value.schedule_id?.id ? n.schedule_id === value.schedule_id?.id : true)
      ) {
        // console.log("P{P{");
        site_clone.push(n.Schedule.Site);
        inspection_clone.push(n);

        data_obj = {
          ...data_obj,
          [n.Schedule?.title]: data_obj[(n.Schedule?.title)]
            ? [
                ...data_obj[(n.Schedule?.title)],
                {
                  score:parseInt(n.score),
                    // ((filtered_answers.length -
                    //   (filtered_answers.length - score_arr.length)) /
                    //   filtered_answers.length) *
                    // 100,
                  title: n.Schedule?.title,
                  schedule_id: n.Schedule?.id,
                  site_id: n.Schedule?.site,
                },
              ]
            : [
                {
                  score:parseInt(n.score),
                    // ((filtered_answers.length -
                    //   (filtered_answers.length - score_arr.length)) /
                    //   filtered_answers.length) *
                    // 100,
                  title: n.Schedule?.title,
                  schedule_id: n.Schedule?.id,
                  site_id: n.Schedule?.site,
                },
              ],
        };

        // let filtered_answers = n.InspectionAnswers?.filter(
        //   (v) => v.parent_id == null
        // );
        // await filtered_answers?.map(async (ans, iAns) => {
        //   if (
        //     ans.value == null ||
        //     ans.value == "" ||
        //     ans.value == 0 ||
        //     ans.value == "[]" ||
        //     ans.value?.length == 0 ||
        //     ans.parent_id !== null
        //   ) {
        //   } else score_arr.push(ans);

        //   if (filtered_answers.length - 1 === iAns) {
        //     data_obj = {
        //       ...data_obj,
        //       [n.Schedule?.title]: data_obj[(n.Schedule?.title)]
        //         ? [
        //             ...data_obj[(n.Schedule?.title)],
        //             {
        //               score:
        //                 ((filtered_answers.length -
        //                   (filtered_answers.length - score_arr.length)) /
        //                   filtered_answers.length) *
        //                 100,
        //               title: n.Schedule?.title,
        //               schedule_id: n.Schedule?.id,
        //               site_id: n.Schedule?.site,
        //             },
        //           ]
        //         : [
        //             {
        //               score:
        //                 ((filtered_answers.length -
        //                   (filtered_answers.length - score_arr.length)) /
        //                   filtered_answers.length) *
        //                 100,
        //               title: n.Schedule?.title,
        //               schedule_id: n.Schedule?.id,
        //               site_id: n.Schedule?.site,
        //             },
        //           ],
        //     };
        //   }
        // });

        n.InspectionShares.map((user) => {
          let name = user.User?.first_name + " " + user.User?.last_name;

          user_obj = {
            ...user_obj,
            [user?.User?.id]: user_obj[(user?.User?.id)]
              ? [...user_obj[(user?.User?.id)], { name, inspection_id: n.id }]
              : [{ name, inspection_id: n.id }],
          };
        });
      }
    });

    // console.log(data_obj);

    let objKeys = Object.keys(data_obj);
    let site_obj = {};
    await objKeys.map(async (v) => {
      let overall_score = 0;

      await data_obj[v].map((val, valI) => {
        site_obj[val.site_id] = val.site_id;
        overall_score += val.score;
        if (valI === data_obj[v].length - 1) {
          data_arr.push([v, overall_score / data_obj[v].length, val.title]);
        }
      });
    });

    // setDataGlobal({
    //   ...dataGlobal,
    //   location: Object.keys(site_obj).length,
    //   auditors: Object.keys(user_obj).length,
    //   audit_name: inspection_clone.length,
    //   audits: objKeys.length,
    //   template_id: value.template_id?.id,
    //   inspection_id: value.inspection_id?.id,
    //   site_id: value.site_id?.id,
    //   site_obj: site_obj,
    //   user_obj: user_obj,
    //   data_obj,
    //   site_clone,
    //   name_arr: data_arr,
    //   inspection_clone,
    // });

    setBarChartData(data_arr);
  }

  async function handleAuditorClick() {
    let data_arr = [
      [
        "User",
        "No of Inspections",
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    await Object.keys(dataGlobal?.user_obj).map((v, i) => {
      let score = dataGlobal.user_obj[v].length;
      data_arr.push([
        dataGlobal.user_obj[v][0].name,
        score,
        dataGlobal.user_obj[v][0].name,
      ]);
    });

    setBarChartData(data_arr);
  }

  function filterByDateChart(row, column) {
    // console.log(row, column, dateChart[row + 1][0]);
    setTableFilterOption("date");
    // setTableFilterDate(dateChart[row + 1][0]);
    setTableFilterDate(row);
  }

  const handlePdfDownload = async (inspection_id,isCompleted,pdf_url) => {

    
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      inspection_id,
      user_id: data.user_id,
      url: GlobalApi.replace("api", ""),
    };
    let package_inquiry = {
      organization_id: data.organization_id,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    console.log(query);

    let query1 = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(GlobalApi + "/Package/pdf_limit?" + query1, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });

    let reqJson = await req.json();
    console.log("reqJson.status_______________________",reqJson.status)
    if (reqJson.status === "Request is Valid") {
      console.log("CREATE PDF CALLED_______________________________",query)
      
      if (isCompleted || (pdf_url !== null && pdf_url !== undefined)) {
        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );
        let pdfDataJson = await pdfData.json();
        console.log("pdfData", pdfDataJson.pdf_url);
        window.open(pdfDataJson.pdf_url, '_blank');
        setDownloadIndex(null);
      } else {
        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );

        const blob = await pdfData.blob();
        // setwaitForResponseWithOverlay( false );

        // const fileURL = URL.createObjectURL( blob );
        
  
        await saveAs(blob);
  
        // await saveAs(GlobalApi + "/Inspection/create-pdf?" + query);
        setDownloadIndex(null);
      }

      // await saveAs(GlobalApi + "/Inspection/create-pdf?" + query);
      // setDownloadIndex(null);
    } else {
      setDownloadIndex(null);
      swal(t("Warning"), reqJson.status, "warning");
    }
  };
  console.log("OPOPOPOP", packageDetails);
  if (packageDetails !== null) {
    return (
      <div style={{ textAlign: "left" }}>
        <Grid container>
          <Grid item xs={12} md={12}>
            <Dashboard
              btnLoader={btnLoader}
              setBtnLoader={setBtnLoader}
              value={value}
              handleSideBarSubmit={handleSideBarSubmit}
              handleSideBarChange={handleSideBarChange}
              templates={templates}
              companies={companies}
              inspections={inspections}
              sites={sites}
              packageDetails={packageDetails}
              handleAuditClick={handleAuditClick}
              handleAuditorClick={handleAuditorClick}
              handleNameClick={handleNameClick}
              dataGlobal={dataGlobal}
              handleLocationClick={handleLocationClick}
              barChartData={barChartData}
              dateChart={dateChart}
              filterByDateChart={filterByDateChart}
              setTableFilterOption={setTableFilterOption}
              tableData={tableData}
              toggletable={toggletable}
              tableFilterDate={tableFilterDate}
              tableFilterOption={tableFilterOption}
              handlePdfDownload={handlePdfDownload}
              setDownloadIndex={setDownloadIndex}
              downloadIndex={downloadIndex}
              openModal={openModalDashboard}
              setModal={setModal}
            />
          </Grid>
        </Grid>
      </div>
    );
  } else {
    return <Spinner />;
  }
}

var getDates = function(startDate, endDate) {
  var dates = [],
    currentDate = startDate,
    addDays = function(days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
  while (currentDate <= endDate) {
    dates.push(currentDate);
    currentDate = addDays.call(currentDate, 1);
  }
  return dates;
};
